(function () {
  'use strict';

  const THREE = window.THREE;
  const ALLOWED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);
  const FIXED_PREVIEW_KEY = '400';
  const CUP_SHAPES = {
    '400': { x: 0.94, y: 0.93, z: 0.94 },
  };
  const CUP_STICKER_CENTER_OFFSETS = { '400': 0.09 };
  const CUP_STICKER_HEIGHT_RATIOS = { '400': 0.6 };
  const MP3_REFERENCE_ICON_DATA = {
    shuffle: 'data:image/png;base64,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',
    repeat: 'data:image/png;base64,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',
  };
  const EXCEL_LAYOUT = {
    baseStickerWidth: 65,
    baseStickerHeight: 90,
    imageWidth: 54,
    imageHeight: 70,
    imageY: 7,
    textY: 77,
    textHeight: 13,
    baseFontSizePt: 25,
    backgroundBuffer: 0,
    cornerRatio: 0,
  };

  function compact(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '');
  }

  function sizeKeyFor(value) {
    const text = compact(value);
    if (text.includes('400ml') || text.includes('14oz')) return '400';
    if (text.includes('500ml') || text.includes('16oz')) return '500';
    if (text.includes('600ml') || text.includes('20oz')) return '600';
    return '';
  }

  function normalizeHex(value) {
    const raw = String(value || '').trim().replace(/^#/, '');
    if (/^[0-9a-f]{3}$/i.test(raw)) {
      return `#${raw.split('').map((character) => character + character).join('').toUpperCase()}`;
    }
    if (/^[0-9a-f]{6}$/i.test(raw)) return `#${raw.toUpperCase()}`;
    return '';
  }

  function foregroundForSticker(value) {
    const hex = normalizeHex(value) || '#FFFFFF';
    const red = parseInt(hex.slice(1, 3), 16);
    const green = parseInt(hex.slice(3, 5), 16);
    const blue = parseInt(hex.slice(5, 7), 16);
    return ((0.2126 * red) + (0.7152 * green) + (0.0722 * blue)) < 145 ? '#FFFFFF' : '#0B0B0C';
  }

  function shortenFilename(value, maximumLength = 38) {
    const filename = String(value || '').trim();
    if (filename.length <= maximumLength) return filename;
    const dotIndex = filename.lastIndexOf('.');
    const extension = dotIndex > 0 ? filename.slice(dotIndex) : '';
    const availableLength = Math.max(8, maximumLength - extension.length - 1);
    return `${filename.slice(0, availableLength)}…${extension}`;
  }

  function roundedRect(context, x, y, width, height, radius) {
    const safeRadius = Math.min(radius, width / 2, height / 2);
    context.beginPath();
    if (safeRadius <= 0) {
      context.rect(x, y, width, height);
      return;
    }
    context.moveTo(x + safeRadius, y);
    context.arcTo(x + width, y, x + width, y + height, safeRadius);
    context.arcTo(x + width, y + height, x, y + height, safeRadius);
    context.arcTo(x, y + height, x, y, safeRadius);
    context.arcTo(x, y, x + width, y, safeRadius);
    context.closePath();
  }

  function formatSocialHashtags(value, maxLength = 46) {
    const raw = String(value || '');
    const words = raw.trim().split(/\s+/).map((word) => word.replace(/^#+/, '')).filter(Boolean);
    let formatted = words.length ? words.map((word) => `#${word}`).join(' ') : '#';
    if (words.length && /\s+#*\s*$|\s$/.test(raw)) formatted += ' #';
    return formatted.slice(0, maxLength).trimEnd();
  }

  function completedSocialHashtags(value) {
    return value.replace(/\s+#$/, '').replace(/^#$/, '').trim();
  }

  class CupConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        clearTimeout(this.disconnectTimer);
        window.addEventListener('resize', this.resizeHandler, { passive: true });
        document.addEventListener('visibilitychange', this.resumeHandler);
        window.addEventListener('pageshow', this.resumeHandler);
        document.addEventListener('submit', this.submitHandler, true);
        this.variantInput?.addEventListener('change', this.variantChangeHandler);
        if (this.renderer) this.resumeViewer();
        else this.viewerPromise = this.initializeViewer();
        return;
      }
      this.initialized = true;
      this.canvas = this.querySelector('[data-cup-canvas]');
      this.stage = this.querySelector('[data-cup-stage]');
      this.loading = this.querySelector('[data-cup-loading]');
      this.form = this.querySelector('[data-cup-form]');
      this.productForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');
      this.upload = this.querySelector('[data-cup-upload]');
      this.consentInput = this.querySelector('[data-cup-consent]');
      this.textInput = this.querySelector('[data-cup-text]');
      this.artistInput = this.querySelector('[data-cup-artist]');
      this.textCount = this.querySelector('[data-cup-text-count]');
      this.status = this.querySelector('[data-cup-status]');
      this.adjustments = this.querySelector('[data-cup-adjustments]');
      this.variantInput = this.productForm?.querySelector('input[name="id"]');
      this.sizeInput = this.querySelector('[data-cup-size-property]');
      this.countInput = this.querySelector('[data-cup-count-property]');
      this.typeInput = this.querySelector('[data-cup-type-property]');
      this.fileNameInput = this.querySelector('[data-cup-file-property]');
      this.textPropertyInput = this.querySelector('[data-cup-text-property]');
      this.songPropertyInput = this.querySelector('[data-cup-song-property]');
      this.artistPropertyInput = this.querySelector('[data-cup-artist-property]');
      this.frameInput = this.querySelector('[data-cup-frame-property]');
      this.positionInput = this.querySelector('[data-cup-position-property]');
      this.scaleInput = this.querySelector('[data-cup-scale-property]');
      this.cartPreviewInput = this.querySelector('[data-cup-cart-preview]');
      this.stickerPrintInput = this.querySelector('[data-cup-sticker-print]');
      this.designParametersInput = this.querySelector('[data-cup-design-parameters]');
      this.framePalette = this.querySelector('[data-cup-frame-palette]');
      this.hexInput = this.framePalette?.querySelector('[data-cup-frame-hex]');
      this.colorInput = this.framePalette?.querySelector('[data-cup-frame-picker]');
      this.price = this.querySelector('[data-cup-price]');
      this.addToCartButton = this.querySelector('[data-cup-add-to-cart]');
      this.checkoutButton = this.querySelector('[data-cup-checkout]');
      this.product = this.readProduct();
      this.stickerTemplate = this.dataset.stickerTemplate === 'social-instagram' || this.product?.handle === 'social-media-cup'
        ? 'social-instagram'
        : (this.dataset.stickerTemplate === 'mp3' || this.product?.handle === 'mp3-cups' ? 'mp3' : 'polaroid');
      this.socialCropCanvas = this.querySelector('[data-cup-social-crop]');
      this.socialZoomInput = this.querySelector('[data-cup-social-zoom]');
      this.socialHashtagsInput = this.querySelector('[data-cup-social-hashtags]');
      this.socialCaptionProperty = this.querySelector('[data-cup-social-caption-property]');
      this.socialHashtagsProperty = this.querySelector('[data-cup-social-hashtags-property]');
      this.socialCrop = { x: 0, y: 0, zoom: 1 };
      this.selectedSizeKey = FIXED_PREVIEW_KEY;
      this.stickerFormat = null;
      this.frameColor = '#FFFFFF';
      this.imageUrl = null;
      this.artwork = null;
      this.artworkTransform = { rotation: 0 };
      this.stickerFontLoaded = false;
      this.purchaseBusy = false;
      this.viewerReady = false;
      this.contextLost = false;
      this.uploadGeneration = 0;
      this.bindViewerLifecycle();
      this.previewBackgroundPromise = this.dataset.previewBackgroundUrl
        ? this.loadImage(this.dataset.previewBackgroundUrl, true)
          .then((image) => { this.previewBackgroundImage = image; })
          .catch((error) => console.error('Cup preview background could not be loaded.', error))
        : Promise.resolve();

      this.bindUI();
      this.addEventListener('input', () => this.updateTextCount());
      this.addEventListener('focusout', () => this.updateTextCount());
      this.addEventListener('focusin', () => this.updateTextCount());
      this.loadStickerFont();
      this.ensureSocialTemplate().catch((error) => console.error('Social Media sticker template could not be loaded.', error));
      if (!this.supportsWebGL()) {
        this.showViewerError('Die 3D-Vorschau benötigt WebGL. Bitte aktiviere die Hardwarebeschleunigung oder verwende einen anderen Browser.');
        return;
      }
      this.viewerPromise = this.initializeViewer();
      this.viewerPromise.then(() => this.restoreCartConfiguration());
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);
      document.removeEventListener('visibilitychange', this.resumeHandler);
      window.removeEventListener('pageshow', this.resumeHandler);
      this.viewerObserver?.disconnect();
      if (this.submitHandler) document.removeEventListener('submit', this.submitHandler, true);
      if (this.variantInput && this.variantChangeHandler) this.variantInput.removeEventListener('change', this.variantChangeHandler);
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      this.disconnectTimer = setTimeout(() => {
        if (this.isConnected) return;
        this.controls?.dispose();
        this.scene?.traverse((object) => {
          object.geometry?.dispose();
          const materials = Array.isArray(object.material) ? object.material : [object.material];
          materials.filter(Boolean).forEach((material) => material.dispose());
        });
        this.printTexture?.dispose();
        this.renderer?.dispose();
        this.renderer = null;
        this.model = null;
        this.labelMesh = null;
        this.lidGroup = null;
        this.viewerReady = false;
      }, 1000);
    }

    bindViewerLifecycle() {
      this.resumeHandler = () => this.resumeViewer();
      document.addEventListener('visibilitychange', this.resumeHandler);
      window.addEventListener('pageshow', this.resumeHandler);
      this.canvas.addEventListener('pointerdown', this.resumeHandler, { passive: true });
      this.canvas.addEventListener('webglcontextlost', (event) => {
        event.preventDefault();
        this.contextLost = true;
        this.renderedArtwork = null;
        this.showStatus('Die 3D-Anzeige wird wiederhergestellt. Dein Bild und deine Einstellungen bleiben erhalten.', true);
      });
      this.canvas.addEventListener('webglcontextrestored', () => {
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.contextLost = false;
          if (this.printTexture) this.printTexture.needsUpdate = true;
          this.resumeViewer();
        });
      });
    }

    resumeViewer() {
      if (!this.isConnected || document.hidden || !this.viewerReady || this.contextLost) return;
      this.viewerVisible = true;
      this.resize();
      this.redrawArtwork();
      this.renderViewer();
      if (!this.animationFrame) this.animate();
    }

    renderViewer() {
      if (!this.isConnected || document.hidden || !this.viewerReady || this.contextLost || !this.renderer) return false;
      try {
        if (this.renderer.getContext().isContextLost()) return false;
        this.controls.update();
        this.renderer.render(this.scene, this.camera);
        if (this.artwork && this.labelMesh?.visible) {
          const newlyRendered = this.renderedArtwork !== this.artwork;
          this.renderedArtwork = this.artwork;
          if (newlyRendered && this.artworkFile && this.artworkInputFile === this.upload.files[0]) {
            this.showStatus(this.dataset.imagePreviewLabel.replace('__FILE__', this.artworkFile.name));
          }
        }
        return true;
      } catch (error) {
        this.renderedArtwork = null;
        if (!this.renderErrorReported) {
          console.error('Cup preview rendering failed.', error);
          this.showStatus('Die 3D-Vorschau ist noch nicht bereit. Dein Bild bleibt gespeichert; bitte versuche es erneut.', true);
          this.renderErrorReported = true;
        }
        return false;
      }
    }

    ensureSocialTemplate() {
      if (this.stickerTemplate !== 'social-instagram' || this.socialTemplateImage) return Promise.resolve();
      if (this.socialTemplatePromise) return this.socialTemplatePromise;
      this.socialTemplatePromise = (async () => {
        for (let attempt = 0; attempt < 3; attempt += 1) {
          try {
            const url = new URL(this.dataset.socialTemplateUrl, location.href);
            if (attempt) url.searchParams.set('cup_retry', String(attempt));
            this.socialTemplateImage = await this.loadImage(url.href, true, 8000);
            this.socialTintedTemplate = null;
            this.redrawArtwork();
            return;
          } catch (error) {
            if (attempt === 2) throw error;
          }
        }
      })().finally(() => { this.socialTemplatePromise = null; });
      return this.socialTemplatePromise;
    }

    async restoreCartConfiguration() {
      const key = new URLSearchParams(window.location.search).get('cup_edit');
      if (!key) return;
      this.setPurchaseBusy(true);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
        if (!cartResponse.ok) throw new Error('Warenkorb nicht erreichbar.');
        const cart = await cartResponse.json();
        const item = cart.items.find((line) => line.key === key && line.handle === this.product.handle);
        if (!item) throw new Error('Dieses Set ist nicht mehr im Warenkorb.');
        const properties = item.properties || {};
        const variant = this.product.variants.find((value) => String(value.id) === String(item.variant_id));
        const picker = document.querySelector('variant-selects');
        if (variant && picker) {
          const groups = picker.querySelectorAll('fieldset, .product-form__input');
          groups.forEach((group, index) => {
            const value = variant.options?.[index] || variant[`option${index + 1}`];
            const select = group.querySelector('select');
            if (select) select.value = value;
            else group.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = input.value === value; });
          });
          this.variantInput.value = variant.id;
          this.syncSelectedVariant();
        }
        const source = properties['_Quelldatei'];
        const sourceUrl = new URL(source?.url || source, window.location.origin);
        if (sourceUrl.protocol !== 'https:' || !['cdn.shopify.com', window.location.hostname].includes(sourceUrl.hostname)) throw new Error('Die gespeicherte Bilddatei kann nicht geöffnet werden.');
        const response = await fetch(sourceUrl.href);
        if (!response.ok) throw new Error('Die gespeicherte Bilddatei konnte nicht geladen werden.');
        const blob = await response.blob();
        const file = new File([blob], properties.Datei || 'motiv.jpg', { type: blob.type });
        const transfer = new DataTransfer();
        transfer.items.add(file);
        this.upload.files = transfer.files;
        await this.handleImage(file);
        if (!this.artwork) throw new Error('Die Bilddatei konnte nicht gelesen werden.');
        this.textInput.value = properties.Bildbeschreibung || properties.Songtitel || properties.Text || '';
        this.textInput.dispatchEvent(new Event('input', { bubbles: true }));
        if (this.artistInput) {
          this.artistInput.value = properties.Interpret || '';
          this.artistInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (this.socialHashtagsInput) {
          this.socialHashtagsInput.value = properties.Hashtags || '';
          this.updateSocialHashtags();
        }
        this.setFrameColor(properties['Sticker-Hintergrundfarbe'] || '#FFFFFF', null, true);
        let design = {};
        try { design = JSON.parse(properties['_Designparameter'] || '{}'); } catch {}
        this.socialCrop = { x: Number(design.x) || 0, y: Number(design.y) || 0, zoom: Number(design.zoom) || 1 };
        this.artworkTransform.rotation = Number(design.rotation) || 0;
        if (this.socialZoomInput) this.socialZoomInput.value = String(this.socialCrop.zoom * 100);
        if (this.fileNameInput) this.fileNameInput.value = properties.Datei || file.name;
        this.consentInput.checked = properties['Bildrechte und Personalisierung bestätigt'] === 'Ja';
        this.productForm.cupEditItem = { key: item.key, quantity: item.quantity };
        this.addToCartButton.textContent = 'Änderungen speichern';
        this.redrawArtwork();
        this.setPurchaseBusy(false);
        this.showStatus('Dein gespeichertes Set ist geladen. Du kannst es jetzt bearbeiten.');
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        this.showStatus(`${error.message} Bitte öffne den Warenkorb erneut.`, true);
      }
    }

    readProduct() {
      try {
        return JSON.parse(this.querySelector('[data-cup-product-json]').textContent);
      } catch (error) {
        console.error('Cup configurator product data could not be read.', error);
        return { variants: [] };
      }
    }

    async loadStickerFont() {
      const fontUrl = this.dataset.stickerFontUrl;
      if (!fontUrl || !window.FontFace || !document.fonts) return;
      try {
        const font = new FontFace('CupPlaylistExcelScript', `url("${fontUrl}") format("truetype")`, {
          style: 'normal',
          weight: '400',
        });
        const loadedFont = await font.load();
        document.fonts.add(loadedFont);
        this.stickerFontLoaded = true;
        this.redrawArtwork();
      } catch (error) {
        console.error('Playlist Script could not be loaded.', error);
      }
    }

    supportsWebGL() {
      try {
        const testCanvas = document.createElement('canvas');
        const context = testCanvas.getContext('webgl2') || testCanvas.getContext('webgl');
        context?.getExtension('WEBGL_lose_context')?.loseContext();
        return Boolean(context);
      } catch (_) {
        return false;
      }
    }

    bindUI() {
      if (!this.productForm || !this.variantInput) {
        this.showStatus('Der Produktbereich konnte nicht gefunden werden. Bitte lade die Seite neu.', true);
        return;
      }
      this.productForm.setAttribute('enctype', 'multipart/form-data');
      this.form.querySelectorAll('[name^="properties["]').forEach((input) => input.setAttribute('form', this.productForm.id));
      this.upload.setAttribute('form', this.productForm.id);
      this.variantChangeHandler = () => this.syncSelectedVariant();
      this.variantInput.addEventListener('change', this.variantChangeHandler);
      this.submitHandler = (event) => {
        if (event.target !== this.productForm || this.validateBeforeSubmit()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      document.addEventListener('submit', this.submitHandler, true);
      this.framePalette?.querySelectorAll('[data-frame-color]').forEach((button) => button.addEventListener('click', () => this.selectFrameColor(button)));
      this.upload.addEventListener('change', (event) => this.handleImage(event.target.files && event.target.files[0]));
      this.textInput?.addEventListener('input', () => {
        if (this.textPropertyInput) this.textPropertyInput.value = this.textInput.value.trim();
        if (this.songPropertyInput) this.songPropertyInput.value = this.textInput.value.trim();
        if (this.socialCaptionProperty) this.socialCaptionProperty.value = this.textInput.value.trim();
        this.updateTextCount();
        this.redrawArtwork();
      });
      this.artistInput?.addEventListener('input', () => {
        if (this.artistPropertyInput) this.artistPropertyInput.value = this.artistInput.value.trim();
        this.redrawArtwork();
      });
      this.socialHashtagsInput?.addEventListener('focus', () => {
        if (!this.socialHashtagsInput.value) this.socialHashtagsInput.value = '#';
      });
      this.socialHashtagsInput?.addEventListener('input', (event) => {
        if (!event.isComposing) this.updateSocialHashtags();
      });
      this.socialHashtagsInput?.addEventListener('compositionend', () => this.updateSocialHashtags());
      this.socialHashtagsInput?.addEventListener('keydown', (event) => {
        if (event.key !== 'Backspace') return;
        const input = this.socialHashtagsInput;
        const cursor = input.selectionStart;
        if (cursor !== input.selectionEnd || input.value[cursor - 1] !== '#') return;
        if (cursor !== 1 && input.value[cursor - 2] !== ' ') return;
        event.preventDefault();
        input.value = cursor === 1 ? '' : input.value.slice(0, cursor - 2) + input.value.slice(cursor);
        input.setSelectionRange(Math.max(0, cursor - 2), Math.max(0, cursor - 2));
        this.updateSocialHashtags(false);
      });
      this.socialHashtagsInput?.addEventListener('blur', () => {
        if (this.socialHashtagsInput.value === '#') this.socialHashtagsInput.value = '';
      });
      this.socialZoomInput?.addEventListener('input', () => this.setSocialZoom(Number(this.socialZoomInput.value) / 100));
      this.socialCropCanvas?.addEventListener('wheel', (event) => {
        if (!this.artwork) return;
        event.preventDefault();
        this.setSocialZoom(this.socialCrop.zoom + (event.deltaY < 0 ? 0.05 : -0.05));
      }, { passive: false });
      this.socialCropCanvas?.addEventListener('pointerdown', (event) => {
        if (!this.artwork) return;
        this.socialCropCanvas.setPointerCapture(event.pointerId);
        this.socialDragStart = { x: event.clientX, y: event.clientY, cropX: this.socialCrop.x, cropY: this.socialCrop.y };
      });
      this.socialCropCanvas?.addEventListener('pointermove', (event) => {
        if (!this.socialDragStart) return;
        const rect = this.socialCropCanvas.getBoundingClientRect();
        this.socialCrop.x = this.socialDragStart.cropX + ((event.clientX - this.socialDragStart.x) / rect.width);
        this.socialCrop.y = this.socialDragStart.cropY + ((event.clientY - this.socialDragStart.y) / rect.height);
        this.redrawArtwork();
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => {
        this.socialCropCanvas?.addEventListener(name, () => { this.socialDragStart = null; });
      });
      this.addToCartButton?.addEventListener('click', () => this.submitPurchase(false));
      this.checkoutButton?.addEventListener('click', () => this.submitPurchase(true));
      this.productForm.addEventListener('product-form:complete', (event) => {
        this.setPurchaseBusy(false);
        if (event.detail?.error) {
          const message = event.detail.message || 'Der Cup konnte nicht in den Warenkorb gelegt werden.';
          this.showStatus(message, true);
          const note = this.querySelector('.cup-configurator__purchase-note');
          if (note) {
            note.textContent = message;
            note.style.color = '#b42318';
            note.setAttribute('role', 'alert');
          }
        }
      });
      this.querySelectorAll('[data-cup-upload], [data-cup-consent], [data-cup-text], [data-cup-artist]').forEach((input) => {
        ['input', 'change'].forEach((eventName) => input.addEventListener(eventName, () => this.clearFieldError(input)));
      });
      this.hexInput?.addEventListener('input', () => this.handleHexInput());
      this.hexInput?.addEventListener('change', () => {
        if (/^#[0-9a-f]{6}$/i.test(this.hexInput.value)) this.setFrameColor(this.hexInput.value);
      });
      this.colorInput?.addEventListener('input', () => this.setFrameColor(this.colorInput.value));
      this.resizeHandler = () => this.resize();
      window.addEventListener('resize', this.resizeHandler, { passive: true });
      this.syncSelectedVariant();
      const activeFrame = this.framePalette?.querySelector('[data-frame-color].is-active') || this.framePalette?.querySelector('[data-frame-color]');
      if (activeFrame) this.selectFrameColor(activeFrame, true);
      this.updateTextCount();
    }

    updateStickerFormat() {
      const next = { width: 46, height: 73, sizeKey: FIXED_PREVIEW_KEY };
      const changed = !this.stickerFormat
        || this.stickerFormat.width !== next.width
        || this.stickerFormat.height !== next.height
        || this.stickerFormat.sizeKey !== next.sizeKey;
      this.stickerFormat = next;
      if (changed && this.model) {
        this.createPrintSurface();
        this.applyCupShape();
        this.redrawArtwork();
      }
    }

    getSelectedVariantFromControls() {
      const variantSelects = document.querySelector(`variant-selects[data-product-id="${this.product?.id}"]`);
      if (!variantSelects) return null;
      const selectedOptions = Array.from(variantSelects.querySelectorAll('.product-form__input')).map((group) => {
        const control = group.querySelector('select') || group.querySelector('input:checked');
        return control?.value;
      }).filter((value) => value !== undefined);
      if (!selectedOptions.length) return null;
      return this.product?.variants?.find((item) => {
        const options = item.options || [item.option1, item.option2, item.option3].filter((value) => value !== null && value !== undefined);
        return selectedOptions.length === options.length && selectedOptions.every((value, index) => String(value) === String(options[index]));
      }) || null;
    }

    syncSelectedVariant() {
      const selectedVariant = this.getSelectedVariantFromControls();
      if (selectedVariant && this.variantInput) this.variantInput.value = selectedVariant.id;
      const variant = selectedVariant || this.product?.variants?.find((item) => String(item.id) === String(this.variantInput?.value));
      if (!variant) return;
      const selectedSizeKey = sizeKeyFor(variant.option1 || variant.title);
      if (!selectedSizeKey) return;
      this.selectedSizeKey = FIXED_PREVIEW_KEY;
      this.updateStickerFormat();
      this.sizeInput.value = ({ '400': 'ca. 400 ml – 14 oz', '500': 'ca. 500 ml – 16 oz', '600': 'ca. 600 ml – 20 oz' })[selectedSizeKey];
      if (this.countInput) this.countInput.value = variant.option2 || '';
      if (this.typeInput) this.typeInput.value = variant.option3 || 'Nur Cups';
      this.dataset.withLid = String(compact(variant.option3).includes('deckel'));
      this.applyCupShape();
      this.updateTotalPrice();
      return variant;
    }

    updateTotalPrice() {
      const variant = this.product?.variants?.find((item) => String(item.id) === String(this.variantInput?.value));
      if (!variant || !this.price) return;
      const currency = this.dataset.currencyCode || 'EUR';
      this.price.textContent = new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(Number(variant.price) / 100);
    }

    selectFrameColor(button, silent) {
      this.setFrameColor(button.dataset.frameColor, button, silent);
    }

    handleHexInput() {
      if (!this.hexInput) return;
      const entered = this.hexInput.value;
      const cursor = this.hexInput.selectionStart ?? entered.length;
      const digitsBeforeCursor = entered.slice(0, cursor).replace(/[^0-9a-f]/gi, '').length;
      const digits = entered.replace(/[^0-9a-f]/gi, '').slice(0, 6).toUpperCase();
      const formatted = `#${digits}`;

      if (this.hexInput.value !== formatted) {
        this.hexInput.value = formatted;
        const nextCursor = Math.min(formatted.length, Math.max(1, digitsBeforeCursor + 1));
        this.hexInput.setSelectionRange(nextCursor, nextCursor);
      }

      this.hexInput.setCustomValidity('');
      if (digits.length === 6) this.setFrameColor(formatted);
    }

    setFrameColor(value, sourceButton, silent) {
      const color = normalizeHex(value);
      if (!color) {
        if (this.hexInput) this.hexInput.setCustomValidity('Bitte gib einen Hex-Code wie #B86A52 ein.');
        return;
      }
      this.hexInput?.setCustomValidity('');
      this.frameColor = color;
      this.dataset.selectedFrameColor = color;
      if (this.frameInput) this.frameInput.value = color;
      if (this.hexInput) this.hexInput.value = color;
      if (this.colorInput) this.colorInput.value = color;
      this.framePalette?.querySelectorAll('[data-frame-color]').forEach((item) => {
        const active = item === sourceButton || item.dataset.frameColor.toUpperCase() === color;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      this.redrawArtwork();
      if (!silent && this.artwork) this.showStatus(`Sticker-Hintergrund ${color} aktualisiert.`);
    }

    async initializeViewer() {
      if (!THREE || !THREE.OrbitControls || !THREE.GLTFLoader) {
        this.showViewerError('Die 3D-Bibliothek konnte nicht geladen werden. Bitte lade die Seite neu.');
        return;
      }
      try {
        this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true, alpha: true, preserveDrawingBuffer: true, powerPreference: 'high-performance' });
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
        this.renderer.toneMappingExposure = 0.92;
        this.renderer.setClearAlpha(0);
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(28, 1, 0.01, 100);
        this.camera.position.set(0, 0.12, 7.8);
        this.addLighting();
        this.controls = new THREE.OrbitControls(this.camera, this.canvas);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.065;
        this.controls.enablePan = false;
        this.controls.minDistance = 3;
        this.controls.maxDistance = 7.8;
        this.controls.minPolarAngle = 0.52;
        this.controls.maxPolarAngle = 2.62;
        const gltf = await this.loadModel(new THREE.GLTFLoader(), this.dataset.modelUrl);
        this.model = gltf.scene;
        this.prepareModel();
        this.scene.add(this.model);
        this.createPrintSurface();
        this.createLid();
        this.applyCupShape();
        this.resize();
        this.viewerReady = true;
        this.redrawArtwork();
        document.fonts?.ready?.then(() => this.redrawArtwork());
        this.loading.hidden = true;
        this.viewerVisible = true;
        if ('IntersectionObserver' in window) {
          this.viewerObserver = new IntersectionObserver(([entry]) => {
            this.viewerVisible = entry.isIntersecting;
          }, { rootMargin: '100px' });
          this.viewerObserver.observe(this.stage);
        }
        this.animate();
        return true;
      } catch (error) {
        console.error('Cup configurator could not load the GLB model.', error);
        this.showViewerError('Die 3D-Vorschau konnte nicht geladen werden. Bitte versuche es erneut.');
        return false;
      }
    }

    loadModel(loader, url) {
      return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Cup model loading timed out.')), 20000);
        loader.load(url, (model) => { clearTimeout(timer); resolve(model); }, undefined,
          (error) => { clearTimeout(timer); reject(error); });
      });
    }

    addLighting() {
      this.scene.add(new THREE.HemisphereLight(0xffffff, 0x657b85, 1.25));
      [[0xffffff, 1.8, [3.5, 4.5, 5]], [0xaedcea, 1.1, [-4, 2, 2]], [0xffffff, 0.55, [0, -2, 3]]].forEach(([color, intensity, position]) => {
        const light = new THREE.DirectionalLight(color, intensity);
        light.position.set(...position);
        this.scene.add(light);
      });
    }

    prepareModel() {
      this.repairReferenceCupDetails();
      this.model.updateMatrixWorld(true);
      const box = new THREE.Box3().setFromObject(this.model);
      const size = box.getSize(new THREE.Vector3());
      this.baseScale = 2.55 / size.y;
      this.model.scale.setScalar(this.baseScale);
      this.model.updateMatrixWorld(true);
      const scaledCenter = new THREE.Box3().setFromObject(this.model).getCenter(new THREE.Vector3());
      this.model.position.sub(scaledCenter);
      this.model.updateMatrixWorld(true);
      this.modelBounds = new THREE.Box3().setFromObject(this.model);
      this.modelSize = this.modelBounds.getSize(new THREE.Vector3());
      this.controls.target.set(0, 0, 0);
      this.cupMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xa6c8d4,
        roughness: 0.2,
        metalness: 0,
        transmission: 0.25,
        ior: 1.45,
        transparent: true,
        opacity: 0.72,
        side: THREE.DoubleSide,
        depthWrite: false,
        clearcoat: 0.3,
        clearcoatRoughness: 0.16,
      });
      this.model.traverse((object) => {
        if (!object.isMesh) return;
        object.material = this.cupMaterial;
        object.renderOrder = 1;
      });
      this.cupMeshes = [];
      this.model.traverse((object) => {
        if (object.isMesh) this.cupMeshes.push(object);
      });
    }

    repairReferenceCupDetails() {
      const bottomProfile = [
        [0, .5658], [.0111, .5658], [.02577, .5658], [.07799, .5658],
        [.15969, .5658], [.26465, .5658], [.36995, .5658], [.414, .5658],
        [.45315, .5658], [.4785, .5658], [.5227, .5658], [.51488, .6499],
        [.52621, .6635], [.5375289224, .6907],
      ];
      const rimProfile = [
        [.772264371, 2.853], [.78066, 2.8692], [.7802, 2.8958],
        [.78342, 2.8963], [.78397, 2.8682], [.84285, 2.8663], [.84331, 2.8755],
        [.84837, 2.8829], [.84837, 2.8953], [.84147, 2.9027], [.83043, 2.9215],
      ];
      this.model.traverse((object) => {
        if (!object.isMesh || !object.name.startsWith('coop_Raindrops')) return;
        const geometry = object.geometry;
        if (geometry.userData.cuplabDetailsRepaired) return;
        const positions = geometry.getAttribute('position');
        const originalIndices = geometry.getIndex();
        if (!positions || !originalIndices) return;
        const retainedIndices = [];
        for (let index = 0; index < originalIndices.count; index += 3) {
          const vertices = [0, 1, 2].map((offset) => originalIndices.getX(index + offset));
          const heights = vertices.map((vertex) => positions.getZ(vertex));
          if (Math.min(...heights) >= 2.8529 || Math.max(...heights) <= .707) continue;
          retainedIndices.push(...vertices);
        }
        geometry.setIndex(retainedIndices);
        geometry.userData.cuplabDetailsRepaired = true;
        [bottomProfile, rimProfile].forEach((profile, index) => {
          const detailGeometry = new THREE.LatheGeometry(profile.map(([radius, height]) => new THREE.Vector2(radius, height)), 512);
          detailGeometry.rotateX(Math.PI / 2);
          const detail = new THREE.Mesh(detailGeometry, object.material);
          detail.name = index === 0 ? 'cuplab-repaired-bottom' : 'cuplab-repaired-rim';
          object.add(detail);
        });
      });
    }

    createPrintSurface() {
      if (this.labelMesh) {
        this.scene.remove(this.labelMesh);
        this.labelMesh.geometry.dispose();
        this.labelMesh.material.dispose();
        this.printTexture.dispose();
      }
      const format = this.stickerFormat || { width: this.numberData('stickerWidthMm', 46), height: this.numberData('stickerHeightMm', 73) };
      const outerWidth = format.width + (EXCEL_LAYOUT.backgroundBuffer * 2);
      const outerHeight = format.height + (EXCEL_LAYOUT.backgroundBuffer * 2);
      const stickerAspect = outerWidth / outerHeight;
      const printHeight = this.modelSize.y * CUP_STICKER_HEIGHT_RATIOS[FIXED_PREVIEW_KEY];
      const previousScale = this.model.scale.clone();
      this.model.scale.setScalar(this.baseScale);
      this.model.updateMatrixWorld(true);
      const raycaster = new THREE.Raycaster();
      const centerHit = this.raycastCupSurface(raycaster, new THREE.Vector3(0, 0, 1));
      if (!centerHit) {
        this.model.scale.copy(previousScale);
        this.model.updateMatrixWorld(true);
        throw new Error('Could not locate the cup exterior for the sticker surface.');
      }
      const meanRadius = Math.hypot(centerHit.point.x, centerHit.point.z);
      const printWidth = printHeight * stickerAspect;
      const thetaLength = Math.min(printWidth / meanRadius, Math.PI * 0.7);
      const geometry = this.createFlushStickerGeometry(raycaster, printHeight, thetaLength, printWidth);
      this.model.scale.copy(previousScale);
      this.model.updateMatrixWorld(true);
      this.printCanvas = document.createElement('canvas');
      this.printCanvas.width = 1200;
      this.printCanvas.height = Math.round(this.printCanvas.width / stickerAspect);
      // Power-of-two display texture permits smooth mipmapping on WebGL 1 too.
      // Keep the production canvas at its original dimensions.
      this.previewTextureCanvas = document.createElement('canvas');
      const previewTextureSize = Math.min(2048, this.renderer.capabilities.maxTextureSize);
      this.previewTextureCanvas.width = previewTextureSize;
      this.previewTextureCanvas.height = previewTextureSize;
      this.printTexture = new THREE.CanvasTexture(this.previewTextureCanvas);
      this.printTexture.encoding = THREE.sRGBEncoding;
      this.printTexture.minFilter = THREE.LinearMipmapLinearFilter;
      this.printTexture.magFilter = THREE.LinearFilter;
      this.printTexture.generateMipmaps = true;
      this.printTexture.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
      this.printMaterial = new THREE.MeshBasicMaterial({ map: this.printTexture, toneMapped: false, transparent: true, side: THREE.FrontSide, depthWrite: false, alphaTest: 0.01 });
      this.labelMesh = new THREE.Mesh(geometry, this.printMaterial);
      this.labelMesh.position.y = -this.modelSize.y * CUP_STICKER_CENTER_OFFSETS[FIXED_PREVIEW_KEY];
      this.labelMesh.visible = false;
      this.labelMesh.renderOrder = 2;
      this.scene.add(this.labelMesh);
    }

    createLid() {
      if (this.lidGroup) {
        this.scene.remove(this.lidGroup);
        this.lidGroup.traverse((object) => {
          if (!object.isMesh) return;
          object.geometry?.dispose();
          if (Array.isArray(object.material)) object.material.forEach((material) => material.dispose());
          else object.material?.dispose();
        });
      }

      const lid = new THREE.Group();
      lid.name = 'Transparenter Flachdeckel mit Kreuzschlitz';
      const radius = Math.max(this.modelSize.x, this.modelSize.z) * 0.535;
      const lidHeight = this.modelSize.y * 0.04;
      this.lidHeight = lidHeight;
      const clearMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xeaf8fc,
        roughness: 0.12,
        metalness: 0,
        transmission: 0.68,
        ior: 1.47,
        transparent: true,
        opacity: 0.58,
        side: THREE.DoubleSide,
        depthWrite: false,
        clearcoat: 0.72,
        clearcoatRoughness: 0.08,
      });
      const rimMaterial = clearMaterial.clone();
      rimMaterial.opacity = 0.72;
      const detailMaterial = new THREE.MeshBasicMaterial({
        color: 0x7f9299,
        transparent: true,
        opacity: 0.34,
        depthWrite: false,
        side: THREE.DoubleSide,
      });

      const addMesh = (geometry, material, y, rotationX) => {
        const mesh = new THREE.Mesh(geometry, material);
        mesh.position.y = y || 0;
        if (rotationX) mesh.rotation.x = rotationX;
        mesh.renderOrder = 3;
        lid.add(mesh);
        return mesh;
      };

      // Flache Hauptscheibe und der breite, leicht nach unten gezogene Schnapprand.
      addMesh(new THREE.CylinderGeometry(radius * 0.88, radius * 0.88, lidHeight * 0.2, 96), clearMaterial, lidHeight * 0.18);
      addMesh(new THREE.CylinderGeometry(radius, radius * 0.955, lidHeight * 1.15, 96, 1, true), rimMaterial, -lidHeight * 0.24);
      addMesh(new THREE.TorusGeometry(radius * 0.955, radius * 0.045, 14, 96), rimMaterial, lidHeight * 0.26, Math.PI / 2);
      addMesh(new THREE.TorusGeometry(radius * 0.963, radius * 0.029, 12, 96), rimMaterial, -lidHeight * 0.7, Math.PI / 2);
      addMesh(new THREE.TorusGeometry(radius * 0.78, radius * 0.021, 12, 96), clearMaterial, lidHeight * 0.26, Math.PI / 2);

      // Der im Referenzbild sichtbare innere, flache Ring um den Kreuzschlitz.
      addMesh(new THREE.CylinderGeometry(radius * 0.57, radius * 0.57, lidHeight * 0.18, 80), clearMaterial, lidHeight * 0.34);
      addMesh(new THREE.TorusGeometry(radius * 0.57, radius * 0.026, 12, 80), rimMaterial, lidHeight * 0.43, Math.PI / 2);

      // Feine Griffstruktur rund um den äußeren Deckelrand.
      const ribGeometry = new THREE.BoxGeometry(radius * 0.018, lidHeight * 0.12, radius * 0.12);
      for (let index = 0; index < 40; index += 1) {
        const angle = (index / 40) * Math.PI * 2;
        const rib = new THREE.Mesh(ribGeometry, detailMaterial);
        rib.position.set(Math.sin(angle) * radius * 0.865, lidHeight * 0.4, Math.cos(angle) * radius * 0.865);
        rib.rotation.y = angle;
        rib.renderOrder = 4;
        lid.add(rib);
      }

      // Zwei sehr schmale Vertiefungen bilden den Kreuzschlitz in der Mitte.
      const slitLength = radius * 0.34;
      const slitWidth = Math.max(radius * 0.012, 0.0015);
      const slitGeometry = new THREE.BoxGeometry(slitWidth, lidHeight * 0.035, slitLength);
      const firstSlit = addMesh(slitGeometry, detailMaterial, lidHeight * 0.455);
      const secondSlit = addMesh(slitGeometry.clone(), detailMaterial, lidHeight * 0.457);
      secondSlit.rotation.y = Math.PI / 2;

      this.lidGroup = lid;
      this.scene.add(lid);
    }

    raycastCupSurface(raycaster, direction, y) {
      const outerRadius = Math.max(this.modelSize.x, this.modelSize.z) * 0.75 + 0.25;
      const origin = direction.clone().multiplyScalar(outerRadius);
      origin.y = y || 0;
      const rayDirection = direction.clone().negate();
      raycaster.set(origin, rayDirection);
      return raycaster.intersectObjects(this.cupMeshes, false)[0] || null;
    }

    createFlushStickerGeometry(raycaster, height, thetaLength, targetWidth) {
      const widthSegments = 96;
      const heightSegments = 48;
      const halfHeight = height / 2;
      const vertices = [];
      const uvs = [];
      const indices = [];
      for (let row = 0; row <= heightSegments; row += 1) {
        const y = halfHeight - (height * row / heightSegments);
        const centerHit = this.raycastCupSurface(raycaster, new THREE.Vector3(0, 0, 1), y);
        if (!centerHit) throw new Error('The sticker extends beyond the cup exterior.');
        const rowRadius = Math.hypot(centerHit.point.x, centerHit.point.z);
        const rowThetaLength = Math.min(targetWidth / rowRadius, Math.PI * 0.7) || thetaLength;
        for (let column = 0; column <= widthSegments; column += 1) {
          const angle = -rowThetaLength / 2 + (rowThetaLength * column / widthSegments);
          const direction = new THREE.Vector3(Math.sin(angle), 0, Math.cos(angle));
          const hit = this.raycastCupSurface(raycaster, direction, y);
          if (!hit) throw new Error('The sticker extends beyond the cup exterior.');
          const point = hit.point.addScaledVector(direction, 0.00025);
          vertices.push(point.x, y, point.z);
          uvs.push(column / widthSegments, 1 - (row / heightSegments));
          if (row < heightSegments && column < widthSegments) {
            const a = row * (widthSegments + 1) + column;
            const b = a + widthSegments + 1;
            indices.push(a, b, a + 1, b, b + 1, a + 1);
          }
        }
      }
      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
      geometry.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
      geometry.setIndex(indices);
      geometry.computeVertexNormals();
      return geometry;
    }

    applyCupShape() {
      if (!this.model || !this.labelMesh) return;
      const shape = CUP_SHAPES[FIXED_PREVIEW_KEY];
      this.model.scale.set(this.baseScale * shape.x, this.baseScale * shape.y, this.baseScale * shape.z);
      this.labelMesh.scale.set(shape.x, shape.y, shape.z);
      const stickerOffset = CUP_STICKER_CENTER_OFFSETS[FIXED_PREVIEW_KEY];
      this.labelMesh.position.y = -this.modelSize.y * stickerOffset * shape.y;
      if (this.lidGroup) {
        this.lidGroup.scale.set(shape.x, shape.y, shape.z);
        this.model.updateMatrixWorld(true);
        const currentCupBounds = new THREE.Box3().setFromObject(this.model);
        const lidOverlap = (this.lidHeight || 0) * 0.42 * shape.y;
        this.lidGroup.position.set(0, currentCupBounds.max.y - lidOverlap, 0);
        this.lidGroup.visible = this.dataset.withLid === 'true';
      }
    }

    async handleImage(file) {
      if (!file) return;
      const generation = ++this.uploadGeneration;
      const inputFile = this.upload.files[0];
      this.imageLoading = true;
      this.updateUploadedFile(null);
      if (!ALLOWED_IMAGE_TYPES.has(file.type)) {
        this.upload.value = '';
        if (this.fileNameInput) this.fileNameInput.value = '';
        this.showStatus('Bitte lade eine JPG-, PNG- oder WEBP-Datei hoch.', true);
        this.imageLoading = false;
        return;
      }
      if (file.size > this.numberData('maxUploadMb', 10) * 1024 * 1024) {
        this.upload.value = '';
        if (this.fileNameInput) this.fileNameInput.value = '';
        this.showStatus(`Die Datei darf maximal ${this.numberData('maxUploadMb', 10)} MB groß sein.`, true);
        this.imageLoading = false;
        return;
      }
      const imageUrl = URL.createObjectURL(file);
      this.showStatus('Dein Bild wird für die 3D-Vorschau vorbereitet …');
      try {
        if (this.fileNameInput) this.fileNameInput.value = shortenFilename(file.name);
        const artwork = await this.loadImage(imageUrl);
        if (generation !== this.uploadGeneration) return;
        this.artwork = artwork;
        this.artworkFile = file;
        this.artworkInputFile = inputFile;
        this.renderedArtwork = null;
        this.renderErrorReported = false;
        this.updateUploadedFile(file);
        this.artworkTransform = { rotation: 0 };
        if (this.stickerTemplate === 'social-instagram') {
          this.socialCrop = { x: 0, y: 0, zoom: 1 };
          if (this.socialZoomInput) this.socialZoomInput.value = '100';
        }
        this.redrawArtwork();
        await Promise.all([this.viewerPromise, this.ensureSocialTemplate()]);
        if (generation !== this.uploadGeneration) return;
        this.redrawArtwork();
        if (this.adjustments) this.adjustments.disabled = false;
        if (this.camera && this.controls) {
          this.controls.target.set(0, 0, 0);
          this.camera.position.set(0, 0.12, this.controls.maxDistance);
          this.camera.lookAt(0, 0, 0);
          this.controls.saveState();
          this.controls.reset();
          this.controls.update();
        }
        if (!this.renderViewer() || this.renderedArtwork !== this.artwork) {
          this.showStatus('Dein Bild ist geladen. Die 3D-Vorschau ist noch nicht bereit; dein Bild bleibt erhalten.', true);
        }
      } catch (error) {
        if (generation !== this.uploadGeneration) return;
        console.error('Uploaded artwork could not be read.', error);
        if (this.artworkFile !== file) {
          this.updateUploadedFile(null);
          this.upload.value = '';
          if (this.fileNameInput) this.fileNameInput.value = '';
        }
        this.showStatus('Das Bild oder die Sticker-Vorlage konnte nicht geladen werden. Bitte wähle dein Bild erneut; deine Einstellungen bleiben erhalten.', true);
      } finally {
        URL.revokeObjectURL(imageUrl);
        if (generation === this.uploadGeneration) this.imageLoading = false;
      }
    }

    updateUploadedFile(file) {
      const confirmation = this.querySelector('[data-cup-uploaded-file]');
      const name = this.querySelector('[data-cup-uploaded-name]');
      const title = this.querySelector('[data-cup-upload-title]');
      const formats = this.querySelector('[data-cup-upload-formats]');
      if (confirmation) confirmation.hidden = !file;
      if (formats) formats.hidden = Boolean(file);
      if (name) {
        name.textContent = file?.name || '';
        name.title = file?.name || '';
      }
      if (title) title.textContent = file ? title.dataset.loadedTitle : title.dataset.emptyTitle;
    }

    loadImage(url, crossOrigin = false, timeout = 15000) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        const timer = setTimeout(() => {
          image.onload = image.onerror = null;
          image.src = '';
          reject(new Error('Image loading timed out.'));
        }, timeout);
        if (crossOrigin) image.crossOrigin = 'anonymous';
        image.onload = () => { clearTimeout(timer); resolve(image); };
        image.onerror = () => { clearTimeout(timer); reject(new Error('Image loading failed.')); };
        image.src = url;
      });
    }

    adjustArtwork(action) {
      if (!this.artwork) return;
      if (action === 'rotate') this.artworkTransform.rotation = (this.artworkTransform.rotation + 90) % 360;
      if (action === 'reset') this.artworkTransform = { rotation: 0 };
      this.redrawArtwork();
    }

    updateTextCount() {
      this.querySelectorAll('textarea[maxlength], input[type="text"][maxlength]').forEach((input) => {
        let count = input === this.textInput ? this.textCount : input.parentElement.querySelector('[data-cup-character-count]');
        if (!count) {
          count = document.createElement('p');
          count.className = 'cup-configurator__character-count';
          count.setAttribute('data-cup-character-count', '');
          input.insertAdjacentElement('afterend', count);
        }
        count.id = `${input.id}-character-count`;
        input.setAttribute('aria-describedby', count.id);
        count.textContent = this.dataset.characterCountLabel
          .replace('__COUNT__', String(input.value.length))
          .replace('__LIMIT__', String(input.maxLength));
      });
    }

    setSocialZoom(zoom) {
      this.socialCrop.zoom = Math.min(2.2, Math.max(1, zoom));
      if (this.socialZoomInput) this.socialZoomInput.value = String(Math.round(this.socialCrop.zoom * 100));
      this.redrawArtwork();
    }

    drawSocialPhoto(context, x, y, width, height) {
      if (!this.artwork) return;
      const naturalWidth = this.artwork.naturalWidth;
      const naturalHeight = this.artwork.naturalHeight;
      const cover = Math.max(width / naturalWidth, height / naturalHeight) * this.socialCrop.zoom;
      const drawWidth = naturalWidth * cover;
      const drawHeight = naturalHeight * cover;
      const limitX = Math.max(0, (drawWidth - width) / 2);
      const limitY = Math.max(0, (drawHeight - height) / 2);
      const offsetX = Math.max(-limitX, Math.min(limitX, this.socialCrop.x * width));
      const offsetY = Math.max(-limitY, Math.min(limitY, this.socialCrop.y * height));
      context.save();
      context.beginPath();
      context.rect(x, y, width, height);
      context.clip();
      context.drawImage(this.artwork, x + ((width - drawWidth) / 2) + offsetX, y + ((height - drawHeight) / 2) + offsetY, drawWidth, drawHeight);
      context.restore();
    }

    getSocialTintedTemplate() {
      if (this.socialTintedTemplate?.color === this.frameColor) return this.socialTintedTemplate.canvas;
      const canvas = document.createElement('canvas');
      canvas.width = this.printCanvas.width;
      canvas.height = this.printCanvas.height;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(this.socialTemplateImage, 0, 0, canvas.width, canvas.height);
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
      const background = [1, 3, 5].map((index) => parseInt(this.frameColor.slice(index, index + 2), 16));
      const inkHex = foregroundForSticker(this.frameColor);
      const ink = [1, 3, 5].map((index) => parseInt(inkHex.slice(index, index + 2), 16));
      const pixelsPerMillimetre = canvas.width / 46;
      for (let y = 0; y < canvas.height; y += 1) {
        const mmY = y / pixelsPerMillimetre;
        for (let x = 0; x < canvas.width; x += 1) {
          const mmX = x / pixelsPerMillimetre;
          if (mmX >= 1.5 && mmX <= 44.5 && mmY >= 12.65 && mmY <= 55.25) continue;
          const storyRadius = Math.hypot(mmX - 4, mmY - 10.75);
          const profileRadius = Math.hypot(mmX - 39.95, mmY - 68.53);
          if (storyRadius >= 1.22 && storyRadius <= 1.84) {
            const offset = ((y * canvas.width) + x) * 4;
            for (let channel = 0; channel < 3; channel += 1) pixels.data[offset + channel] = background[channel];
            continue;
          }
          const inProfileHighlight = Math.hypot(mmX - Math.max(38.19, Math.min(41.46, mmX)), mmY - 68.55) <= 2.8;
          if (inProfileHighlight && profileRadius >= 1.6) {
            const offset = ((y * canvas.width) + x) * 4;
            for (let channel = 0; channel < 3; channel += 1) pixels.data[offset + channel] = background[channel];
            continue;
          }
          if (storyRadius < 1.45 || profileRadius < 1.6) {
            const offset = ((y * canvas.width) + x) * 4;
            const radius = storyRadius < 1.45 ? 1.22 : 1.38;
            const distance = storyRadius < 1.45 ? storyRadius : profileRadius;
            const coverage = Math.max(0, Math.min(1, (radius - distance) * pixelsPerMillimetre));
            if (coverage < 1) {
              for (let channel = 0; channel < 3; channel += 1) {
                pixels.data[offset + channel] = Math.round(pixels.data[offset + channel] * coverage + background[channel] * (1 - coverage));
              }
            }
            continue;
          }
          const offset = ((y * canvas.width) + x) * 4;
          const red = pixels.data[offset];
          const green = pixels.data[offset + 1];
          const blue = pixels.data[offset + 2];
          if (mmX >= 1.3 && mmX < 4.5 && mmY >= 55.53 && mmY <= 58.44) {
            const originalCoverage = Math.max(0, red - Math.min(green, blue)) / 255;
            const edgeCoverage = Math.max(0, Math.min(1, (originalCoverage - .15) / .7));
            const coverage = edgeCoverage * edgeCoverage * (3 - 2 * edgeCoverage);
            const heart = [255, 0, 51];
            for (let channel = 0; channel < 3; channel += 1) {
              pixels.data[offset + channel] = Math.round(heart[channel] * coverage + background[channel] * (1 - coverage));
            }
            continue;
          }
          if (Math.max(red, green, blue) - Math.min(red, green, blue) >= 25) continue;
          const shade = ((red * 299) + (green * 587) + (blue * 114)) / 255000;
          for (let channel = 0; channel < 3; channel += 1) {
            pixels.data[offset + channel] = Math.round((background[channel] * shade) + (ink[channel] * (1 - shade)));
          }
        }
      }
      context.putImageData(pixels, 0, 0);
      const storyGradient = context.createLinearGradient(2.37 * pixelsPerMillimetre, 12.38 * pixelsPerMillimetre, 5.63 * pixelsPerMillimetre, 9.12 * pixelsPerMillimetre);
      storyGradient.addColorStop(0, '#FEDA75');
      storyGradient.addColorStop(.3, '#FA7E1E');
      storyGradient.addColorStop(.65, '#D62976');
      storyGradient.addColorStop(1, '#7A35BA');
      context.strokeStyle = storyGradient;
      context.lineWidth = .18 * pixelsPerMillimetre;
      context.beginPath();
      context.arc(4 * pixelsPerMillimetre, 10.75 * pixelsPerMillimetre, 1.63 * pixelsPerMillimetre, 0, Math.PI * 2);
      context.stroke();
      this.socialTintedTemplate = { color: this.frameColor, canvas };
      return canvas;
    }

    redrawSocialArtwork() {
      if (!this.socialTemplateImage) return;
      const context = this.printCanvas.getContext('2d');
      const { width, height } = this.printCanvas;
      const px = width / 46;
      const photo = { x: 2 * px, y: 12.65 * px, width: 42 * px, height: 42.6 * px };
      const layoutScale = 42 / 43;
      const layoutInset = 23 * (1 - layoutScale) * px;
      context.clearRect(0, 0, width, height);
      context.fillStyle = this.frameColor;
      context.fillRect(0, 0, width, height);
      context.drawImage(this.getSocialTintedTemplate(), layoutInset, 0, width * layoutScale, height);
      context.fillRect(1.3 * px, 8.60 * px, 43.4 * px, 0.36 * px);
      context.fillRect(1.5 * px, 12.60 * px, 43 * px, 42.93 * px);
      this.drawSocialPhoto(context, photo.x, photo.y, photo.width, photo.height);

      context.save();
      context.translate(layoutInset, 0);
      context.scale(layoutScale, 1);
      context.fillStyle = this.frameColor;
      context.fillRect(1.5 * px, 58.5 * px, 43 * px, 6.95 * px);
      const caption = (this.textInput?.value.trim() || 'Deine Bildbeschreibung.').slice(0, 25);
      const tags = (completedSocialHashtags(this.socialHashtagsInput?.value || '') || '#thecuplab.de #memories').slice(0, 40);
      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';
      context.fillStyle = foregroundForSticker(this.frameColor);
      context.font = `${1.48 * px}px Arial, Helvetica, sans-serif`;
      const prefix = 'thecuplab.de  ';
      const available = 41.5 * px;
      let first = caption;
      let second = '';
      while (first.length && context.measureText(prefix + first).width > available) {
        second = first.slice(-1) + second;
        first = first.slice(0, -1);
      }
      context.fillText(prefix + first, 2.25 * px, 60.1 * px);
      if (second) {
        while (second.length && context.measureText(second).width > available) second = second.slice(0, -1);
        context.fillText(second.trim(), 2.25 * px, 62.13 * px);
      }
      context.fillStyle = foregroundForSticker(this.frameColor) === '#FFFFFF' ? '#91B7FF' : '#184CA5';
      context.font = `${1.38 * px}px Arial, Helvetica, sans-serif`;
      let fittedTags = tags;
      const tagLines = [];
      let tagLine = '';
      for (const word of fittedTags.split(/\s+/)) {
        const candidate = tagLine ? `${tagLine} ${word}` : word;
        if (tagLine && context.measureText(candidate).width > available) {
          tagLines.push(tagLine);
          tagLine = word;
        } else tagLine = candidate;
      }
      if (tagLine) tagLines.push(tagLine);
      if (second || tagLines.length > 2) {
        context.fillText(tags, 2.25 * px, (second ? 64.2 : 62.52) * px, available);
      } else {
        tagLines.forEach((line, index) => context.fillText(line, 2.25 * px, (62.52 + index * 2.03) * px, available));
      }
      context.restore();
      this.updatePrintTexture();
      this.labelMesh.visible = true;
      if (this.positionInput) this.positionInput.value = `x=${this.socialCrop.x.toFixed(3)}, y=${this.socialCrop.y.toFixed(3)}`;
      if (this.scaleInput) this.scaleInput.value = `${Math.round(this.socialCrop.zoom * 100)}%`;
      this.redrawSocialCropPreview();
    }

    updatePrintTexture() {
      const context = this.previewTextureCanvas.getContext('2d');
      const { width, height } = this.previewTextureCanvas;
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      context.clearRect(0, 0, width, height);
      context.drawImage(this.printCanvas, 0, 0, width, height);
      this.printTexture.needsUpdate = true;
    }

    redrawSocialCropPreview() {
      if (!this.socialCropCanvas || !this.printCanvas) return;
      const context = this.socialCropCanvas.getContext('2d');
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      context.fillStyle = '#F4F4F4';
      context.fillRect(0, 0, this.socialCropCanvas.width, this.socialCropCanvas.height);
      const px = this.printCanvas.width / 46;
      context.drawImage(this.printCanvas, 2 * px, 12.65 * px, 42 * px, 42.6 * px,
        0, 0, this.socialCropCanvas.width, this.socialCropCanvas.height);
    }

    redrawArtwork() {
      this.renderedArtwork = null;
      try {
        this.drawArtwork();
        this.renderViewer();
      } catch (error) {
        if (this.labelMesh) this.labelMesh.visible = false;
        console.error('Cup sticker drawing failed.', error);
        this.showStatus('Die Sticker-Vorschau konnte nicht erstellt werden. Bitte wähle dein Bild erneut.', true);
      }
    }

    drawArtwork() {
      if (!this.printCanvas || !this.labelMesh) return;
      if (this.stickerTemplate === 'social-instagram') {
        if (!this.artwork || !this.socialTemplateImage) {
          this.labelMesh.visible = false;
          this.redrawSocialCropPreview();
          return;
        }
        this.redrawSocialArtwork();
        return;
      }
      if (this.stickerTemplate === 'mp3') {
        if (!this.artwork) {
          this.labelMesh.visible = false;
          return;
        }
        this.redrawMp3Artwork();
        return;
      }
      if (!this.artwork) return;
      const context = this.printCanvas.getContext('2d');
      const { width, height } = this.printCanvas;
      const format = this.stickerFormat || { width: 46, height: 73 };
      const outerWidth = format.width + (EXCEL_LAYOUT.backgroundBuffer * 2);
      const pixelsPerMillimetre = width / outerWidth;
      const bodyX = EXCEL_LAYOUT.backgroundBuffer * pixelsPerMillimetre;
      const bodyY = EXCEL_LAYOUT.backgroundBuffer * pixelsPerMillimetre;
      const bodyWidth = format.width * pixelsPerMillimetre;
      const scaleX = format.width / EXCEL_LAYOUT.baseStickerWidth;
      const scaleY = format.height / EXCEL_LAYOUT.baseStickerHeight;
      const imageWidth = EXCEL_LAYOUT.imageWidth * scaleX * pixelsPerMillimetre;
      const imageHeight = EXCEL_LAYOUT.imageHeight * scaleY * pixelsPerMillimetre;
      const imageX = bodyX + ((bodyWidth - imageWidth) / 2);
      const imageY = bodyY + (EXCEL_LAYOUT.imageY * scaleY * pixelsPerMillimetre);
      const textWidth = imageWidth;
      const textHeight = EXCEL_LAYOUT.textHeight * scaleY * pixelsPerMillimetre;
      const textX = bodyX + ((bodyWidth - textWidth) / 2);
      const textY = bodyY + (EXCEL_LAYOUT.textY * scaleY * pixelsPerMillimetre);
      const fontScale = Math.min(scaleX, scaleY);
      const fontPixels = EXCEL_LAYOUT.baseFontSizePt * fontScale * (25.4 / 72) * pixelsPerMillimetre;
      const text = this.textInput?.value.trim() || '';

      context.clearRect(0, 0, width, height);
      context.fillStyle = this.frameColor;
      roundedRect(context, 0, 0, width, height, Math.min(width, height) * EXCEL_LAYOUT.cornerRatio);
      context.fill();
      context.save();
      roundedRect(context, 0, 0, width, height, Math.min(width, height) * EXCEL_LAYOUT.cornerRatio);
      context.clip();
      context.translate(imageX + (imageWidth / 2), imageY + (imageHeight / 2));
      context.rotate(THREE.MathUtils.degToRad(this.artworkTransform.rotation));
      const quarterTurn = Math.abs(this.artworkTransform.rotation % 180) === 90;
      const rotationScale = quarterTurn ? Math.min(imageWidth / imageHeight, imageHeight / imageWidth) : 1;
      context.drawImage(this.artwork, -(imageWidth * rotationScale) / 2, -(imageHeight * rotationScale) / 2, imageWidth * rotationScale, imageHeight * rotationScale);
      context.restore();
      context.save();
      context.beginPath();
      context.rect(textX, textY, textWidth, textHeight);
      context.clip();
      context.fillStyle = foregroundForSticker(this.frameColor);
      context.font = `${fontPixels}px CupPlaylistExcelScript, "Playlist Script", cursive`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText(text, textX + (textWidth / 2), textY + (textHeight / 2));
      context.restore();
      this.updatePrintTexture();
      this.labelMesh.visible = true;
      this.positionInput.value = 'Automatisch zentriert';
      this.scaleInput.value = 'Excel-Stickerformat automatisch';
    }

    redrawMp3Artwork() {
      const context = this.printCanvas.getContext('2d');
      const { width, height } = this.printCanvas;
      const format = this.stickerFormat || { width: 46, height: 73 };
      const pixelsPerMillimetre = width / format.width;
      const millimetresToPixels = (value) => value * pixelsPerMillimetre;
      const ink = foregroundForSticker(this.frameColor);
      const photoX = millimetresToPixels(3.9);
      const photoY = millimetresToPixels(5.7);
      const photoWidth = millimetresToPixels(38.2);
      const photoHeight = millimetresToPixels(49.3);
      const photoRight = photoX + photoWidth;
      const title = this.textInput?.value.trim() || 'Dein Songtitel';
      const artist = this.artistInput?.value.trim() || 'Interpret';

      context.clearRect(0, 0, width, height);
      context.fillStyle = this.frameColor;
      context.fillRect(0, 0, width, height);

      context.save();
      context.beginPath();
      context.rect(photoX, photoY, photoWidth, photoHeight);
      context.clip();
      if (this.artwork) {
        context.translate(photoX + (photoWidth / 2), photoY + (photoHeight / 2));
        context.rotate(THREE.MathUtils.degToRad(this.artworkTransform.rotation));
        context.drawImage(this.artwork, -photoWidth / 2, -photoHeight / 2, photoWidth, photoHeight);
      }
      context.restore();

      context.fillStyle = ink;
      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';
      const drawLabel = (value, baseline, size, weight) => {
        let fitted = millimetresToPixels(size);
        const minimum = millimetresToPixels(0.9);
        context.font = `${weight} ${fitted}px Arial, Helvetica, sans-serif`;
        while (fitted > minimum && context.measureText(value).width > millimetresToPixels(31)) {
          fitted -= millimetresToPixels(0.05);
          context.font = `${weight} ${fitted}px Arial, Helvetica, sans-serif`;
        }
        context.fillText(value, photoX, millimetresToPixels(baseline));
      };
      drawLabel(title, 58.4, 2.35, 700);
      drawLabel(artist, 61.2, 1.75, 400);

      context.beginPath();
      context.moveTo(millimetresToPixels(40.7), millimetresToPixels(59.3));
      context.bezierCurveTo(millimetresToPixels(40.3), millimetresToPixels(58.8), millimetresToPixels(39.6), millimetresToPixels(59.1), millimetresToPixels(39.8), millimetresToPixels(59.7));
      context.bezierCurveTo(millimetresToPixels(39.9), millimetresToPixels(60.2), millimetresToPixels(40.7), millimetresToPixels(60.6), millimetresToPixels(40.7), millimetresToPixels(60.6));
      context.bezierCurveTo(millimetresToPixels(40.7), millimetresToPixels(60.6), millimetresToPixels(41.5), millimetresToPixels(60.2), millimetresToPixels(41.6), millimetresToPixels(59.7));
      context.bezierCurveTo(millimetresToPixels(41.8), millimetresToPixels(59.1), millimetresToPixels(41.1), millimetresToPixels(58.8), millimetresToPixels(40.7), millimetresToPixels(59.3));
      context.closePath();
      context.fill();

      const lineY = millimetresToPixels(63.5);
      const lineLeft = photoX;
      const lineRight = photoRight;
      context.strokeStyle = ink;
      context.fillStyle = ink;
      context.lineWidth = Math.max(2, millimetresToPixels(0.25));
      context.lineCap = 'round';
      context.beginPath();
      context.moveTo(lineLeft, lineY);
      context.lineTo(lineRight, lineY);
      context.stroke();
      context.beginPath();
      context.arc(lineLeft + ((lineRight - lineLeft) * (80 / 220)), lineY, millimetresToPixels(0.56), 0, Math.PI * 2);
      context.fill();

      context.font = `${millimetresToPixels(1.25)}px Arial, sans-serif`;
      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';
      context.fillText('1:20', lineLeft, millimetresToPixels(65.65));
      context.textAlign = 'right';
      context.fillText('3:40', lineRight - millimetresToPixels(0.45), millimetresToPixels(65.65));

      const controlsTop = millimetresToPixels(67.5);
      const controlsY = millimetresToPixels(68.63);
      const controlsBottom = millimetresToPixels(69.75);
      context.fillStyle = ink;
      this.drawMp3ReferenceIcon(context, 'shuffle', lineLeft, controlsY - millimetresToPixels(1.25), millimetresToPixels(2.55), millimetresToPixels(2.5), ink);
      context.beginPath();
      context.moveTo(millimetresToPixels(14.7), controlsTop);
      context.lineTo(millimetresToPixels(12.8), controlsY);
      context.lineTo(millimetresToPixels(14.7), controlsBottom);
      context.closePath();
      context.fill();
      context.fillRect(millimetresToPixels(12.4), controlsTop, millimetresToPixels(0.42), millimetresToPixels(2.25));
      const pauseRadius = millimetresToPixels(2.25);
      context.beginPath();
      context.arc(width / 2, controlsY, pauseRadius, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = this.frameColor;
      context.fillRect(millimetresToPixels(22.25), controlsY - millimetresToPixels(0.95), millimetresToPixels(0.38), millimetresToPixels(1.9));
      context.fillRect(millimetresToPixels(23.36), controlsY - millimetresToPixels(0.95), millimetresToPixels(0.38), millimetresToPixels(1.9));
      context.fillStyle = ink;
      context.beginPath();
      context.moveTo(millimetresToPixels(31.1), controlsTop);
      context.lineTo(millimetresToPixels(33), controlsY);
      context.lineTo(millimetresToPixels(31.1), controlsBottom);
      context.closePath();
      context.fill();
      context.fillRect(millimetresToPixels(33), controlsTop, millimetresToPixels(0.42), millimetresToPixels(2.25));
      this.drawMp3ReferenceIcon(context, 'repeat', lineRight - millimetresToPixels(2.5), controlsY - millimetresToPixels(1.25), millimetresToPixels(2.55), millimetresToPixels(2.5), ink);

      this.updatePrintTexture();
      this.labelMesh.visible = true;
      this.positionInput.value = 'Automatisch zentriert';
      this.scaleInput.value = 'Excel-Stickerformat automatisch';
    }

    getMp3ReferenceIcon(name) {
      this.mp3ReferenceIcons ||= {};
      const existing = this.mp3ReferenceIcons[name];
      if (existing?.complete && existing.naturalWidth) return existing;
      if (existing) return null;

      const image = new Image();
      image.decoding = 'async';
      image.onload = () => this.redrawArtwork();
      image.src = MP3_REFERENCE_ICON_DATA[name];
      this.mp3ReferenceIcons[name] = image;
      return null;
    }

    drawMp3ReferenceIcon(context, name, x, y, width, height, color) {
      const image = this.getMp3ReferenceIcon(name);
      if (!image) return;

      const source = document.createElement('canvas');
      source.width = image.naturalWidth;
      source.height = image.naturalHeight;
      const sourceContext = source.getContext('2d', { willReadFrequently: true });
      sourceContext.drawImage(image, 0, 0);

      const pixels = sourceContext.getImageData(0, 0, source.width, source.height);
      const hex = normalizeHex(color);
      const red = parseInt(hex.slice(1, 3), 16);
      const green = parseInt(hex.slice(3, 5), 16);
      const blue = parseInt(hex.slice(5, 7), 16);
      for (let index = 0; index < pixels.data.length; index += 4) {
        const brightness = Math.max(pixels.data[index], pixels.data[index + 1], pixels.data[index + 2]);
        pixels.data[index] = red;
        pixels.data[index + 1] = green;
        pixels.data[index + 2] = blue;
        pixels.data[index + 3] = Math.min(255, Math.max(0, (brightness - 8) * 2));
      }
      sourceContext.putImageData(pixels, 0, 0);
      context.drawImage(source, x, y, width, height);
    }

    setPurchaseBusy(isBusy) {
      this.purchaseBusy = isBusy;
      if (isBusy && !this.purchaseInertElements) {
        this.purchaseInertElements = [this.form, document.querySelector('variant-selects'), this.productForm?.querySelector('[name="quantity"]')?.closest('.product-form__quantity')]
          .filter(Boolean).map((element) => ({ element, inert: element.inert }));
        this.purchaseInertElements.forEach(({element}) => { element.inert = true; });
      } else if (!isBusy) {
        this.purchaseInertElements?.forEach(({element, inert}) => { element.inert = inert; });
        this.purchaseInertElements = null;
      }
      [this.addToCartButton, this.checkoutButton].filter(Boolean).forEach((button) => {
        button.setAttribute('aria-disabled', String(isBusy));
        button.disabled = isBusy;
      });
    }

    getCartPendingDetails() {
      const properties = [];
      const allowedPrivate = new Set(['_Größe', '_Anzahl Cups', '_Ausführung']);
      const visibleKeys = new Set(['Datei', 'Text', 'Songtitel', 'Interpret', 'Bildbeschreibung', 'Hashtags', 'Social-Media-Stil', 'Sticker-Hintergrundfarbe']);
      const values = new Map();
      this.querySelectorAll('[name^="properties["]').forEach((input) => {
        const key = input.name.match(/^properties\[(.+)\]$/)?.[1];
        if (!key || input.disabled || input.type === 'file' || !input.value) return;
        if (!allowedPrivate.has(key) && !visibleKeys.has(key)) return;
        if (key === '_Größe' || key === '_Anzahl Cups' || key === '_Ausführung') {
          properties.push({ label: key === '_Anzahl Cups' ? 'Anzahl' : key.slice(1), value: input.value });
        } else values.set(key, input.value);
      });
      values.forEach((value, key) => {
        if ((key === 'Songtitel' || key === 'Bildbeschreibung') && values.get('Text') === value) return;
        properties.push({ label: key === 'Sticker-Hintergrundfarbe' ? 'Stickerfarbe' : key, value });
      });
      const variant = this.product.variants.find((item) => String(item.id) === String(this.variantInput?.value));
      const quantity = this.productForm.cupEditItem?.quantity || parseInt(this.productForm.querySelector('[name="quantity"]')?.value, 10) || 1;
      return {
        title: `${this.product.title} × ${quantity}`,
        price: new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.dataset.currencyCode || 'EUR' }).format(Number(variant?.price || 0) * quantity / 100),
        properties,
        preparingLabel: this.dataset.cartPreparingLabel,
        previewLabel: this.dataset.cartPreviewLabel,
      };
    }

    async submitPurchase(goToCheckout) {
      if (this.purchaseBusy) return;
      this.syncSelectedVariant();
      if (!this.validateBeforeSubmit()) return;
      this.setPurchaseBusy(true);
      const drawer = !goToCheckout ? document.querySelector('cart-drawer') : null;
      let pendingPanel;
      try {
        pendingPanel = drawer?.beginAdd?.(this.addToCartButton, this.getCartPendingDetails());
        this.showStatus('Deine Vorschau und Druckvorlage werden vorbereitet …');
        await Promise.all([
          this.prepareCartPreview().then((file) => drawer?.updateAddPreview?.(file, pendingPanel)),
          this.prepareStickerPrint(),
        ]);
        drawer?.updateAddStatus?.(this.dataset.cartSavingLabel, pendingPanel);
        this.productForm.dataset.redirectCheckout = goToCheckout ? 'true' : 'false';
        const submitButton = this.productForm.querySelector('button[type="submit"][name="add"]');
        if (!submitButton) throw new Error('Der Warenkorb-Button konnte nicht gefunden werden.');
        this.productForm.requestSubmit(submitButton);
      } catch (error) {
        drawer?.finishAdd?.();
        drawer?.close?.();
        console.error('Personalized cart preview could not be prepared.', error);
        this.setPurchaseBusy(false);
        this.showStatus('Die Vorschau konnte nicht gespeichert werden. Bitte versuche es erneut.', true);
      }
    }

    async prepareCartPreview() {
      if (!this.cartPreviewInput) return;
      const blob = await this.captureConfiguredCup();
      const extension = blob.type === 'image/jpeg' ? 'jpg' : 'png';
      const file = new File([blob], `${this.stickerTemplate}-cup-vorschau.${extension}`, { type: blob.type || 'image/png', lastModified: Date.now() });
      this.productForm.cupPreviewFile = file;
      if (window.DataTransfer) {
        try {
          const transfer = new DataTransfer();
          transfer.items.add(file);
          this.cartPreviewInput.files = transfer.files;
        } catch (error) {
          console.info('Die Vorschau wird direkt an den Warenkorb übertragen.', error);
        }
      }
      return file;
    }

    async prepareStickerPrint() {
      if (!this.printCanvas || !this.labelMesh?.visible || !this.stickerPrintInput) {
        throw new Error('Die personalisierte Druckvorlage ist noch nicht bereit.');
      }
      const productionCanvas = document.createElement('canvas');
      productionCanvas.width = this.printCanvas.width;
      productionCanvas.height = Math.round(productionCanvas.width * 72 / 46);
      const productionContext = productionCanvas.getContext('2d');
      if (!productionContext) throw new Error('Die Druckvorlage konnte nicht erstellt werden.');
      productionContext.imageSmoothingEnabled = true;
      productionContext.imageSmoothingQuality = 'high';
      productionContext.drawImage(this.printCanvas, 0, 0, productionCanvas.width, productionCanvas.height);
      const blob = await new Promise((resolve, reject) => {
        productionCanvas.toBlob((result) => result ? resolve(result) : reject(new Error('Die Druckvorlage ist leer.')), 'image/png');
      });
      const file = new File([blob], `${this.stickerTemplate}-sticker-druckvorlage-46x72mm.png`, {
        type: 'image/png', lastModified: Date.now()
      });
      this.productForm.cupStickerPrintFile = file;
      if (window.DataTransfer) {
        try {
          const transfer = new DataTransfer();
          transfer.items.add(file);
          this.stickerPrintInput.files = transfer.files;
        } catch (error) {
          console.info('Die Druckvorlage wird direkt an den Warenkorb übertragen.', error);
        }
      }
      if (this.designParametersInput) {
        this.designParametersInput.value = JSON.stringify({
          version: 2,
          style: this.stickerTemplate,
          width_mm: 46,
          height_mm: 72,
          background: this.frameColor,
          rotation: this.artworkTransform?.rotation || 0,
          x: Number(this.socialCrop?.x?.toFixed(4) || 0),
          y: Number(this.socialCrop?.y?.toFixed(4) || 0),
          zoom: Number(this.socialCrop?.zoom?.toFixed(4) || 1)
        });
      }
    }

    async captureConfiguredCup() {
      if (!this.previewBackgroundImage) {
        await new Promise((resolve) => {
          const timer = setTimeout(resolve, 800);
          Promise.resolve(this.previewBackgroundPromise).then(() => { clearTimeout(timer); resolve(); }, () => { clearTimeout(timer); resolve(); });
        });
      }
      return new Promise((resolve, reject) => {
        if (!this.renderer || !this.scene || !this.camera) {
          if (!this.printCanvas) return reject(new Error('Die Vorschau ist noch nicht bereit.'));
          this.printCanvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('Sticker preview is empty.')), 'image/png');
          return;
        }

        const previousPosition = this.camera.position.clone();
        const previousQuaternion = this.camera.quaternion.clone();
        const previousTarget = this.controls?.target.clone();
        this.camera.position.set(0, 0.12, 5.9);
        this.camera.lookAt(0, 0, 0);
        this.controls?.target.set(0, 0, 0);
        this.camera.updateMatrixWorld(true);
        this.renderer.render(this.scene, this.camera);

        const preview = document.createElement('canvas');
        preview.width = 1000;
        preview.height = 1000;
        const context = preview.getContext('2d');
        if (this.previewBackgroundImage) {
          context.drawImage(this.previewBackgroundImage, 0, 0, preview.width, preview.height);
        } else {
          context.fillStyle = '#F1EAE2';
          context.fillRect(0, 0, preview.width, preview.height);
        }
        const sourceWidth = this.canvas.width;
        const sourceHeight = this.canvas.height;
        const scale = Math.min((preview.width * 0.92) / sourceWidth, (preview.height * 0.92) / sourceHeight);
        const drawWidth = sourceWidth * scale;
        const drawHeight = sourceHeight * scale;
        context.drawImage(this.canvas, (preview.width - drawWidth) / 2, (preview.height - drawHeight) / 2, drawWidth, drawHeight);

        this.camera.position.copy(previousPosition);
        this.camera.quaternion.copy(previousQuaternion);
        if (previousTarget) this.controls.target.copy(previousTarget);
        this.camera.updateMatrixWorld(true);
        this.renderer.render(this.scene, this.camera);

        preview.toBlob((blob) => blob ? resolve(blob) : reject(new Error('Cup preview is empty.')), 'image/jpeg', 0.9);
      });
    }

    updateSocialHashtags(format = true) {
      const input = this.socialHashtagsInput;
      if (!input) return;
      if (format) {
        const cursor = input.selectionStart ?? input.value.length;
        const formattedCursor = formatSocialHashtags(input.value.slice(0, cursor), input.maxLength).length;
        const formatted = formatSocialHashtags(input.value, input.maxLength);
        if (input.value !== formatted) {
          input.value = formatted;
          input.setSelectionRange(Math.min(formattedCursor, formatted.length), Math.min(formattedCursor, formatted.length));
        }
      }
      if (this.socialHashtagsProperty) this.socialHashtagsProperty.value = completedSocialHashtags(input.value);
      this.updateTextCount();
      this.redrawArtwork();
    }

    validateBeforeSubmit() {
      this.renderViewer();
      if (this.imageLoading || (this.upload.files.length && (!this.artwork || this.artworkInputFile !== this.upload.files[0]
        || !this.labelMesh?.visible || !this.viewerReady || this.contextLost || this.renderedArtwork !== this.artwork))) {
        this.showStatus('Bitte warte, bis dein Bild auf dem Cup angezeigt wird. Die Vorschau ist noch nicht bereit.', true);
        return false;
      }
      if (this.dataset.requireUpload === 'true' && !this.upload.files.length) {
        return this.markMissing(this.upload, 'Bitte lade zuerst ein Bild hoch.');
      }
      if (this.textInput && !this.textInput.value.trim()) {
        const message = this.stickerTemplate === 'mp3' ? 'Bitte gib einen Songtitel ein.'
          : this.stickerTemplate === 'social-instagram' ? 'Bitte gib eine Bildbeschreibung ein.'
            : 'Bitte gib deinen Wunschtext ein.';
        return this.markMissing(this.textInput, message);
      }
      if (this.artistInput && !this.artistInput.value.trim()) {
        return this.markMissing(this.artistInput, 'Bitte gib einen Interpreten ein.');
      }
      if (this.consentInput && !this.consentInput.checked) {
        return this.markMissing(this.consentInput, 'Bitte bestätige die Bildrechte, AGB und den Widerrufshinweis.');
      }
      if (this.fileNameInput && this.upload.files[0]) this.fileNameInput.value = shortenFilename(this.upload.files[0].name);
      if (this.textPropertyInput && this.textInput) this.textPropertyInput.value = this.textInput.value.trim();
      if (this.songPropertyInput && this.textInput) this.songPropertyInput.value = this.textInput.value.trim();
      if (this.artistPropertyInput && this.artistInput) this.artistPropertyInput.value = this.artistInput.value.trim();
      if (this.socialHashtagsProperty && this.socialHashtagsInput) {
        this.socialHashtagsProperty.value = completedSocialHashtags(formatSocialHashtags(this.socialHashtagsInput.value, this.socialHashtagsInput.maxLength));
      }
      const variant = this.getSelectedVariantFromControls()
        || this.product.variants.find((item) => String(item.id) === String(this.variantInput.value));
      if (variant && this.variantInput) this.variantInput.value = variant.id;
      if (!variant || !variant.available) {
        this.showStatus('Diese Größe ist derzeit nicht verfügbar.', true);
        return false;
      }
      return true;
    }

    markMissing(input, message) {
      if (!input) return false;
      const container = input.closest('.cup-configurator__step, .cup-configurator__consent, .cup-product-option') || input.parentElement;
      if (container) {
        container.classList.add('cup-field-error');
        let note = container.querySelector('.cup-field-error__message');
        if (!note) {
          note = document.createElement('p');
          note.className = 'cup-field-error__message';
          note.setAttribute('role', 'alert');
          container.appendChild(note);
        }
        note.textContent = message;
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      input.setAttribute('aria-invalid', 'true');
      window.setTimeout(() => {
        if (input === this.upload) this.querySelector('.cup-configurator__upload')?.focus();
        else input.focus({ preventScroll: true });
      }, 220);
      this.showStatus(message, true);
      return false;
    }

    clearFieldError(input) {
      const container = input.closest('.cup-configurator__step, .cup-configurator__consent, .cup-product-option');
      container?.classList.remove('cup-field-error');
      container?.querySelector('.cup-field-error__message')?.remove();
      input.removeAttribute('aria-invalid');
    }

    showStatus(message, isError) {
      this.status.textContent = message;
      this.status.classList.toggle('is-error', Boolean(isError));
    }

    showViewerError(message) {
      this.viewerReady = false;
      this.loading.hidden = false;
      this.loading.textContent = message;
      this.loading.classList.add('cup-configurator__loading--error');
    }

    numberData(name, fallback) {
      const value = Number(this.dataset[name]);
      return Number.isFinite(value) ? value : fallback;
    }

    resize() {
      if (!this.renderer || !this.stage) return;
      const { width, height } = this.stage.getBoundingClientRect();
      if (!width || !height) return;
      this.renderer.setSize(width, height, false);
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
    }

    animate() {
      this.animationFrame = null;
      if (!this.isConnected) return;
      this.animationFrame = requestAnimationFrame(() => this.animate());
      if (document.hidden || this.contextLost) return;
      if (!this.viewerVisible) {
        const bounds = this.stage.getBoundingClientRect();
        if (bounds.bottom < -100 || bounds.top > innerHeight + 100) return;
      }
      this.renderViewer();
    }
  }

  if (!customElements.get('cup-3d-configurator')) {
    customElements.define('cup-3d-configurator', CupConfigurator);
  }
}());
